export default "__VITE_ASSET__CAHIy$NH__"